<template>
  <div class="tag-list">
    <div v-for="(item, i) in showList" :key="i" class="tag-item">{{ item }}</div>
    <div
        v-if="showBtn"
        :class="['tag-item', 'expand-btn', expendStatus ? 'collapse' : 'expand']"
        @click="expandChange"
    >
        &nbsp;&nbsp;&nbsp;&nbsp;
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    row: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      showList: [],
      expendStatus: false,
      showBtn: true,
    };
  },
  watch: {
    list: {
      handler(val) {
        this.showList = val;
        this.showBtn = true;
        this.$nextTick(() => {
          this.computedShowList();
        });
      },
      immediate: true,
    },
  },
  methods: {
    computedShowList() {
      const wrapWidth = this.$el.clientWidth;
      const paddingLeft = window.getComputedStyle ? Math.ceil(parseFloat(window.getComputedStyle(this.$el).paddingLeft)) : 0;

      const tagEls = document.querySelectorAll('.tag-list .tag-item:not(.expand-btn)');
      const expandEl = document.querySelector('.expand-btn');

      let targetIndex = this.list.length - 1;
      const targetRow = Math.max(this.row, 1);
      let curRow = 0;
      let isExpand = false;

      for (let i = 0; i < tagEls.length; i += 1) {
        const tagEl = tagEls[i];
        const { offsetLeft: x } = tagEl;
        // 换行了
        if (x <= paddingLeft) curRow += 1;
        // 判断需不需要展开收起
        if (curRow > targetRow) {
          targetIndex = i - 1;
          isExpand = true;
          break;
        }
      }
      this.showBtn = isExpand;
      if (!isExpand) return; // 不需要，全部展示
      const lastEl = tagEls[targetIndex];
      // 剩余空间能不能放下展开收起按钮
      if ((wrapWidth - lastEl.offsetLeft - lastEl.offsetWidth - 9) < expandEl.offsetWidth) {
        targetIndex -= 1;
      }
      const sliceCount = targetIndex + 1;
      this.sliceCount = sliceCount;
      this.showList = this.list.slice(0, sliceCount);
    },
    expandChange() {
      this.showList = this.list.slice(0, this.expendStatus ? this.sliceCount : this.list.length);
      this.expendStatus = !this.expendStatus;
    },
  },
};
</script>

<style lang="less" scoped>
.tag-list {
    position: relative;
    min-height: 100px;
    .tag-item {
        display: inline-block;
        height: 26px;
        line-height: 26px;
        padding: 0 12px;
        background-color: #F6F6F6;
        color: @black;
        font-size: 12px;
        margin: 0 6px 6px 0;
        border-radius: 13px;

    }
    .expand-btn {
        margin-right: 0;
        background-size: 16px 16px;
        background-position: center center;
        background-repeat: no-repeat;
        &.expand {
            background-image: url(~@/assets/images/icon/expand.png);
        }
        &.collapse {
            background-image: url(~@/assets/images/icon/collapse.png);
        }
    }
}

</style>
